import axios from 'axios';

import { env } from 'config';
import { OrderType, UserRole } from 'enums';
import {
  CascadesCashbackData,
  PaginatedData,
  QueryParams,
  Shop,
  ShopIntegrationConfig,
  ShopPayoutTrader,
} from 'types';
import { apiUtils } from 'utils';

import { createCrudApi } from './crud.api';

const path = '/shop';
const url = `${env.apiUrl}${path}`;

const getReferrals = async (): Promise<Shop[]> =>
  (await axios.get(`${url}/referrals`)).data;

const getIntegrationConfig =
  (shopId: string) =>
  async (params?: Partial<QueryParams>): Promise<ShopIntegrationConfig> => {
    const res = await apiUtils.getWithQueryParams(
      `${url}/${shopId}/integrations`,
      params,
    );
    return res.data;
  };

const updateIntegrationConfig = async ({
  shopId,
  data,
}: {
  shopId: string;
  data: ShopIntegrationConfig;
}): Promise<ShopIntegrationConfig> =>
  (await axios.patch(`${url}/${shopId}/integrations`, data)).data;

const getPayoutTraders = async (shopId: string): Promise<ShopPayoutTrader[]> =>
  (await axios.get(`${url}/${shopId}/payout-traders`)).data;

const getCascadesCashbackForOrderType =
  (orderType: OrderType) =>
  async (params?: QueryParams): Promise<PaginatedData<CascadesCashbackData>> =>
    (
      await apiUtils.getWithQueryParams(`${url}/cascades/paginated`, {
        ...params,
        orderType,
      })
    ).data;

const crudApi = createCrudApi<Shop>(path);

export const shopsApi = {
  ...crudApi,
  getAllAsMerchant: crudApi.getAllAsRole(UserRole.Merchant), // just a shortcut as it's often in use
  getReferrals,
  getIntegrationConfig,
  updateIntegrationConfig,
  getPayoutTraders,
  getCascadesCashbackForOrderType,
};
